(function CruiseSearchAdvancedSearch($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		Adzuki.onload('/CruiseSearch/AdvancedSearch', function onload()
		{
			$('aside#search').addClass('hidden');
		});
	});
}(jQuery, window.Adzuki || {}));
